import { createContext, useContext, useState } from "react";
import { Snackbar, Alert, Slide } from "@mui/material";
import PropTypes from "prop-types";  // Import PropTypes for validation

const ToastContext = createContext();

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

export const ToastProvider = ({ children }) => {
  const [queue, setQueue] = useState([]);
  const [currentToast, setCurrentToast] = useState(null);

  const processQueue = () => {
    if (queue.length > 0) {
      setCurrentToast(queue[0]);
      setQueue((prev) => prev.slice(1));
    }
  };

  const showToast = (
    message,
    type = "success",
    options = {}
  ) => {
    const toast = {
      message,
      type,
      duration: options.duration || 3000,
      position: options.position || {
        vertical: "top",
        horizontal: "right"
      }
    };

    setQueue((prev) => [...prev, toast]);

    if (!currentToast) {
      setTimeout(processQueue, 100);
    }
  };

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setCurrentToast(null);
    setTimeout(processQueue, 300);
  };

  return (
    <ToastContext.Provider
      value={{
        success: (msg, opt) => showToast(msg, "success", opt),
        error: (msg, opt) => showToast(msg, "error", opt),
        warning: (msg, opt) => showToast(msg, "warning", opt),
        info: (msg, opt) => showToast(msg, "info", opt),
      }}
    >
      {children}

      {currentToast && (
        <Snackbar
          open={true}
          autoHideDuration={currentToast.duration}
          onClose={handleClose}
          anchorOrigin={currentToast.position}
          TransitionComponent={SlideTransition}
        >
          <Alert
            severity={currentToast.type}
            variant="filled"
            onClose={handleClose}
            sx={{ width: "100%" }}
          >
            {currentToast.message}
          </Alert>
        </Snackbar>
      )}
    </ToastContext.Provider>
  );
};

// PropTypes validation for ToastProvider
ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,  // Validate children as required node
};

export const useToast = () => useContext(ToastContext);
